import { FormikProps } from 'formik';
import React from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useSelector } from 'react-redux';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { YesNoIndicators } from '../../../../../global/models/api-model';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { ClergyNewHireFormValues } from '../models/new-hire-form-model';
import { useNewHireBishopDetails } from '../hooks/useNewHireBishopDetails';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { BishopDetails } from '../models/new-hire-model';
import { GetDioceseLicensedInOptions, GetLicensedByOptions } from '../helpers/clergy-type-helper';
import { FieldAutomationIds } from '../../../../../global/constants/field-automation-ids';

interface Props {
    newHireProps: NewHireProps;
	labelSettings: LabelSettingProps;	
    formProps: FormikProps<any>;
}
export function NewHireClergyType(props: Props) {
	const { newHireProps, labelSettings, formProps } = props;

	const clergyNewHireFormValues: ClergyNewHireFormValues = formProps?.values as ClergyNewHireFormValues;

	const isTecNo = clergyNewHireFormValues?.is_TEC === YesNoIndicators.No;
	const isAnotherDenomination = clergyNewHireFormValues?.is_another_denomination === YesNoIndicators.Yes;

	const bishopDetailsLoaded = useNewHireBishopDetails();
	const bishopDetails = useSelector<TcsmStates, BishopDetails[]>(state => state?.newHireState?.bishopDetails);

	const isLicensedByLoaded = !!clergyNewHireFormValues.diocese_licensed_in;	
	
	const dioceseLicensedInOptions = GetDioceseLicensedInOptions(bishopDetails);
	const licensedByOptions =  GetLicensedByOptions(bishopDetails, clergyNewHireFormValues.diocese_licensed_in);
	
	const isChoiceOptions = [
		{
			label: labelSettings?.yesText,
			value: YesNoIndicators.Yes,
		},
		{
			label: labelSettings?.noText,
			value: YesNoIndicators.No,
		},
	];

	function OnDioceseLicensedInChange(event){
		const newValue = event?.target?.value;

		if (!newValue) return;

		formProps.setFieldValue('diocese_licensed_in', newValue);		
	}

	function RenderIsAnotherDenomination(){
		if (!isAnotherDenomination) return null;

		return (<>
			<FormField
				name='date_licensing'
				label={newHireProps?.dateLicensingLabel}
				component='datePicker'
				touched={formProps.touched}
				errors={formProps.errors}
				required
				autoWidth
				testId={FieldAutomationIds.dateOfLicensing}
			/>
			<FormField
				name='diocese_licensed_in'
				label={newHireProps?.dioceseLicensedInLabel}				
				placeHolder={labelSettings?.selectDefaultText}
				component='input'
				options={dioceseLicensedInOptions}
				errors={formProps.errors}
				touched={formProps.touched}
				onChange={OnDioceseLicensedInChange}
				select
				required
				testId={FieldAutomationIds.dioLicensedInDropdown}
			/>
			<FormField
				name='licensed_by'
				label={newHireProps?.licensedByLabel}				
				placeHolder={labelSettings?.selectDefaultText}
				component='input'
				options={licensedByOptions}
				errors={formProps.errors}
				touched={formProps.touched}
				select
				required
				disabled={!isLicensedByLoaded}
				testId={FieldAutomationIds.licensedByDropdown}
			/>
		</>);
	}

	function RenderTecNo(){
		if (!isTecNo) return null;

		return (
			<DividerSection removeDivider greySection>                                
				<FormField
					name='is_another_denomination'
					label={newHireProps?.anotherDenominationLabel}
					component="radioGroup"
					options={isChoiceOptions}
					touched={formProps.touched}
					errors={formProps.errors}
					required
					testId={FieldAutomationIds.anotherDenomination}
					/>
				<RenderIsAnotherDenomination />
			</DividerSection>
		);
	}

	if (!bishopDetailsLoaded) {
		return <LoadingCircle />;
	}

	return (
		<div>
			<WysiwygWithReactLink content={newHireProps?.clergyTypeInstructions} />
			<DividerSection removeDivider>
				<FormGroup>
					<FormField
						name='is_TEC'
						label={newHireProps.clergyTypeLabel}
						component="radioGroup"
						options={isChoiceOptions}
						touched={formProps.touched}
						errors={formProps.errors}
						required
						testId={FieldAutomationIds.clergyIsTECQuestionRadio}

						/>

					<RenderTecNo />
				</FormGroup>
			</DividerSection>
		</div>
	);
}